export const loadImage = src => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve(image);
  image.onerror = () => reject(new Error('This photo could not be opened.'));
  image.src = src;
});

// Percentage coordinates match the original's rotated bounding box, as returned
// by react-easy-crop. The server uses the same quarter-turn geometry.
export const previewCrop = async (src, area, rotation) => {
  const image = await loadImage(src);
  const sideways = rotation === 90 || rotation === 270;
  const rotated = document.createElement('canvas');
  rotated.width = sideways ? image.naturalHeight : image.naturalWidth;
  rotated.height = sideways ? image.naturalWidth : image.naturalHeight;
  const context = rotated.getContext('2d');
  context.fillStyle = '#101113';
  context.fillRect(0, 0, rotated.width, rotated.height);
  context.translate(rotated.width / 2, rotated.height / 2);
  context.rotate(rotation * Math.PI / 180);
  context.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);
  const output = document.createElement('canvas');
  output.width = 180; output.height = 180;
  output.getContext('2d').drawImage(
    rotated, area.x / 100 * rotated.width, area.y / 100 * rotated.height,
    area.width / 100 * rotated.width, area.height / 100 * rotated.height,
    0, 0, output.width, output.height,
  );
  const result = output.toDataURL('image/jpeg', 0.9);
  rotated.width = 0; rotated.height = 0;
  return result;
};